import type {
  ActivityType,
  Entry,
  GlucoseSubEntry,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type { Reading } from "src/types"

type RequiredProperties = ActivityType.Glucose | "export_source"

export function glucoseSubEntryToReading(
  startedAt: Entry["started_at"],
  subEntry: Pick<GlucoseSubEntry, RequiredProperties>,
): Reading {
  return {
    startedAt,
    glucose: subEntry.glucose,
    source: null,
    readingType: "entry",
  }
}
